var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-card"},[_c('PageTitle',{attrs:{"title":_vm.$t('cycleParameters.title'),"description":_vm.$t('cycleParameters.description')}}),_c('CycleParameters')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }